// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './payment.model';
export * from './purchase.model';
export * from './supplier.model';
// @endindex